import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { EvTaskTypes, RegistrationForm } from "../_loadingHelpers/EvTask";
import Tooltip from '../../moreCore/UI/Floating/Tooltip';

class EvTaskRegistrationAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
	//templateString = template; // Standard verwenden...


    itemClickDlg: MdsLax<InstanceType<typeof GenericDialog>>;

    private tableFormatterHeadings(originalHeading: string, colName: string) {
        switch (colName) {
            case "myRegistrationStatus":

                let employeeID = window.sessionInfo?.sessionData?.CurrentEmployeeId;

                let icon = this.createFontawesomeIcon("fas fa-user-check");

                let tooltip = new Tooltip();
                tooltip.setup({
                    targetnode: icon,
                    content: this.translations["EvTask__RegisterAgenda_Tooltip_MyRegistration"],
                    subtitle: this.translations["EvTask__RegisterAgenda_Tooltip_MyRegistration_Subtitle"],
                    icon: icon.className,
                    //_debugKeepOpen: 1000 * 1000
                });

                return icon;


                break;
            default:
                return false;
        }
    }

    private tableFormatter(cell: StaticTable.StaticTableCell<EvTaskTypes.EvTaskListData>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        switch (colName) {
            case "myRegistrationStatus":

                let employeeID = window.sessionInfo?.sessionData?.CurrentEmployeeId;
                let status = entity.tmp_status_current_employee;
                let iconClass = "fas fa-question";

                switch (status) {
                    case "available":
                        iconClass = "far fa-circle w3-text-blue";
                        break;

                    case "unavailable":
                        iconClass = "fas fa-ban w3-text-red";
                        break;

                    case "applied":
                        iconClass = "far fa-user-circle w3-text-orange";
                        break;

                    case "assignedToMe":
                        iconClass = "fas fa-user-circle w3-text-green";
                        break;

                    case "assignedToOther":
                        iconClass = "far fa-user secondaryTXT";
                        break;
                }

                let icon = this.createFontawesomeIcon(iconClass);

                let tooltip = new Tooltip();
                tooltip.setup({
                    targetnode: node,
                    content: entity.tmp_statustext_current_employee,
                    delayMS: 100,
                });

                node.innerHTML = icon.outerHTML;
                return true;
                break;
            //default:
            //    node.innerHTML = value;
            //    return true;
        }

        return false;
    }

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
    //    this.createContextButton({
    //        label: "??",
    //        callback: lang.hitch(this, this._onClick_Context),
    //        placement: "top",
    //        /*iconClass: "fas fa-calendar-times",*/
    //        permanent: false
    //    });
    }

    private _onClick_Context() {

    }

    private _onClick_Row(row: StaticTable.StaticTableRow<EvTaskTypes.EvTaskListData>) {
        this.showEvTaskRegistration(row.rowGroup.entity);
    }

    private showEvTaskRegistration(data: EvTaskTypes.EvTaskListData) {
        let dlg = new GenericDialog();

        let registration = new RegistrationForm();

        registration.on("saved", lang.hitch(this, this._onRegistrationSaved, dlg, registration));

        registration.on("saving", function () {
            dlg.disableAllButtons(true);
        });

        dlg.show(registration,
            "EvTaskRegistration__MainTitle",
            null,
            null,
            "close",
            lang.hitch(this, this._onTaskRegistrationDlgResult, dlg, registration)
        );

        registration.setup(data.ID);
    }

    private _onTaskRegistrationDlgResult(dlg: MdsLax<InstanceType<typeof GenericDialog>>, registrationForm: MdsLax<InstanceType<typeof RegistrationForm>>, result: number) {

    }

    private _onRegistrationSaved(dlg: MdsLax<InstanceType<typeof GenericDialog>>, registration: MdsLax<InstanceType<typeof RegistrationForm>>, result: boolean) {

        dlg.disableAllButtons(false);

        if (result) {
            this.reload();
        } else {
            
        }
        
    }
    
    private startAgenda(hasPrivilege: boolean) {
        if (!hasPrivilege) {
            this.destroy();
            return;
        }

        this.setupAgendaView(
            "EvTask/GetRegistrationAgendaFilterOptions",
            "EvTask/GetRegistrationAgendaList",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this.tableFormatter), // Standard-Formatter
            null,
            null,
            new Date()
            //lang.hitch(this, this.dateSelectFct)
            //    [{
            //        name: "default",
            //        label: "default",
            //        rows: [{
            //            attributes: ["gDisp_1"],
            //            colNamesInternal: ["gDisp_1"],
            //            colspans: [0],
            //            headings: ["Anzeige"],
            //        }]
            //    }]
        );

    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.setTableHeadingFormatter(lang.hitch(this, this.tableFormatterHeadings));

        this.hasUserRole("EvTask_Registration", lang.hitch(this, this.startAgenda));

    }
    
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvTaskRegistrationAgenda);